<template>
    <div>
        <navBox></navBox>
        <div class="banner">
            <img src="https://www-api.multi-metaverse.com:81/uploads/20221222/pic/qGDb2w9vUZhjZ1tdrliYQ6qWHOrghwglFLMvxBya.png" alt="" />
        </div>

        <subNav></subNav>
        <div class="stockPerformance">
            <div class="wrap">
                <div class="update">
                    <div data-qmod-tool="interactivechart" data-qmod-params='{"symbol":"MMV"}' class="qtool"></div>
                </div>
                <!-- <div class="title">STOCK PERFORMANCE</div>
                <div class="price">
                    <div class="real">
                        <div class="headline">Real time stock price</div>
                        <div class="hkd"><span class="fl">HKD</span><span class="num">451.8</span></div>
                        <div class="percent"><img src="@/assets/investor-Relation/percent.png" alt="">-18.8（-4.00%）</div>
                    </div>
                    <div class="chart">
                        <div class="caption">
                            <span class="ttwo">TTWO.O</span>
                            <span class="change">
                                <el-select v-model="value" placeholder="请选择" class="select">
                                    <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                                <el-select v-model="value" placeholder="请选择" class="select">
                                    <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                            </span>
                        </div>
                        <div class="img">
                            <img
                                src="@/assets/investor-Relation/stock-two.png"
                                alt=""
                            />
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
        <!-- <mapBox></mapBox> -->
        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footerBox/footerBox";
import navBox from "@/components/navBox/navBox";
import subNav from "@/components/subNav/subNav";
import mapBox from "@/components/mapBox/mapBox";
export default {
    name: "stockPerformance",
    components: { footerBox, navBox, subNav, mapBox },
    data() {
        return {
            options: [
                {
                    value: "选项1",
                    label: "Technical Analysis",
                },
                {
                    value: "选项2",
                    label: "Technical Analysis",
                },
                {
                    value: "选项3",
                    label: "Technical Analysis",
                },
                {
                    value: "选项4",
                    label: "Technical Analysis",
                },
                {
                    value: "选项5",
                    label: "Technical Analysis",
                },
            ],
            value: "",
        };
    },
};
</script>
<style lang="less" scoped>
.wrap {
    width: 1200px;
    margin: 0 auto;
}

/*banner*/
.banner img {
    width: 100%;
    // height: 220px;
}
//内容
.update{
    text-align: center;
    min-height: 300px;
    line-height: 200px;
    font-size: 30px;
    font-weight: bold;
    color: gray;
    font-family: 'Lucida Bright';
    padding-bottom: 20px;
}
.stockPerformance {
    //padding-bottom: 200px;
    .title {
        font-size: 30px;
        color: #333333;
        font-weight: bold;
        padding: 70px 0 50px 0;
    }
    .price{
        height: 565px;
        border: 1px solid #dcdcdc;
        display: flex;
        .real{
            width: 330px;
            background: #f2f2f2;
            text-align: center;
            .headline{
                margin: 160px 0 50px 0;
                font-size: 14px;
            }
            .hkd{
                margin-bottom: 30px;
                .fl{
                    color: #333333;
                    font-size: 14px;
                }
                .num{
                    color: #444444;
                    font-size: 36px;
                    margin-left: 20px;
                }
            }
            .percent{
                font-size: 14px;
                color: #f43b00;
                img{
                    margin-right: 10px;
                }
            }
        }
        .chart{
            padding: 65px;
            .caption{
                border-bottom: 1px solid #e9e9e9;
                margin-bottom: 15px;
                height: 50px;
                line-height: 50px;
                padding-bottom: 10px;
                .ttwo{
                    font-size: 14px;
                    color: #333333;
                    font-weight: bold;
                }
                .change{
                    float: right;
                    .select{
                        margin-left: 20px;
                    }
                }
            }
        }
    }
}
</style>